import { Flex, Loader, Paper, SegmentedControl, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { NotificationSettingValueDictionary } from '#/shared/dictionaries';
import { useMediaQuery } from '@mantine/hooks';
import { NotificationSettingValue, NotificationType } from '#/entities/notification-setting';
import { Module } from '#/shared/types';
import { useState } from 'react';

export type NotificationSettingItem = {
  id: string;
  title: string;
  notificationTypes: NotificationType[];
  value: NotificationSettingValue;
};

type Props = {
  item: NotificationSettingItem;
  source: Module;
  renderLabel?: (item: any) => React.ReactNode;
  onChange?: (
    value: NotificationSettingValue,
    item: NotificationSettingItem,
    source: Module
  ) => Promise<void>;
};

export const NotificationSettingItem = ({ item, renderLabel, onChange, source }: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 32em)');
  const [isLoading, setIsLoading] = useState(false);

  const isEmpty = item.notificationTypes.length === 0;

  const notificationSettingValueDictionary = new NotificationSettingValueDictionary(t);
  const segmentedData = notificationSettingValueDictionary.toSegmentedControlItems(renderLabel);

  const onChangeHandler = async (value: string) => {
    setIsLoading(true);

    await onChange?.(Number(value) as NotificationSettingValue, item, source);

    setIsLoading(false);
  };

  return (
    <Paper radius="md" key={item.id} py="xs" pl={{ base: 'xs', sm: 'md' }} pr="xs" bg="grey.0">
      <Flex key={item.id} justify="space-between" align="center" wrap="wrap" gap="sm">
        <Text c="#101828" size="md" style={{ flex: '1 1 150px' }}>
          {item.title}
        </Text>
        <Flex w="xs" align="center">
          {isLoading && <Loader size="xs" />}
        </Flex>
        <SegmentedControl
          disabled={isLoading || isEmpty}
          data={segmentedData}
          color="accent"
          bg="white"
          radius="md"
          size="md"
          orientation={isMobile ? 'vertical' : 'horizontal'}
          value={String(item.value)}
          onChange={onChangeHandler}
        />
      </Flex>
    </Paper>
  );
};
